import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL, TOKEN } from "../../../variables/constants";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

function AddSommeMin({ show, handleClose, editMode, selectedSommeMin, sommeMins, onAdd, onUpdate }) {
  const [libelle, setLibelle] = useState("");
  const [valeur, setValeur] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editMode && selectedSommeMin) {
      setLibelle(selectedSommeMin.libelleParametre || "");
      setValeur(selectedSommeMin.valeur || "");
    } else {
      setLibelle("");
      setValeur("");
    }
  }, [editMode, selectedSommeMin]);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmedLibelle = libelle.trim().toLowerCase();

    const isDuplicate = !editMode && sommeMins?.some(
      (item) => item.libelleParametre.trim().toLowerCase() === trimmedLibelle
    );

    if (isDuplicate) {
      toast.error("Cette ligne  existe déjà.");
      setLoading(false);
      return;
    }

    const sommeMinData = {
      ...selectedSommeMin,
      libelleParametre: libelle.trim(),
      valeur: valeur,
      typeParametre: "SOMME_MIN",
    };

    const request = editMode
      ? axios.put(`${API_URL}/api/parametre`, JSON.stringify(sommeMinData), {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        })
      : axios.post(`${API_URL}/api/parametre`, JSON.stringify(sommeMinData), {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        });

    request
      .then((res) => {
        toast.success(editMode ? "Modifié avec succès" : "Ajouté avec succès");
        editMode ? onUpdate(res.data) : onAdd(res.data);
        handleClose();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de l'enregistrement.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button type="button" className="btn-close btn-primary" onClick={handleClose}></button>
        <div className="text-center mb-4">
          <h4>{editMode ? "Modifier" : "Ajouter"} une somme minimale</h4>
        </div>
        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-12">
            <label className="form-label">Libellé</label>
            <input
              type="text"
              name="libelle"
              value={libelle}
              onChange={(e) => setLibelle(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="col-12">
            <label className="form-label">Montant</label>
            <input
              type="number"
              name="valeur"
              value={valeur}
              onChange={(e) => setValeur(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="col-12 text-center mt-3">
            <button type="submit" className="btn btn-primary me-2" disabled={loading}>
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Annuler</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default AddSommeMin;
